import api from './api';

/**
 * Look up a provider or organization by NPI number.
 * Proxied through our backend to avoid CORS issues.
 * Returns a normalized object or null if not found.
 */
export async function lookupNPI(npi) {
  const { data } = await api.get('/api/v1/settings/npi-lookup', { params: { npi } });
  return data.result ?? null;
}
